import axios from "axios";
import axiosInstance from "@/services/https/global";
import CONFIG from "@/config";

const baseUrl = `${CONFIG.BASE_URL}/wayapay-settlement-service/api/v1`;

const toSettlementError = (error) => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;
    const base = typeof data === "object" && data !== null ? data : { message: data };
    const err = new Error(base.message ?? "Request failed");
    Object.assign(err, base, { statusCode: error.response?.status });
    return err;
  }
  return new Error("An unexpected error occurred");
};

export const getSettlements = async (params = {}) => {
  const queryParams = {};

  if (params.page !== undefined) queryParams.page = params.page;
  if (params.size !== undefined) queryParams.size = params.size;
  if (params.status !== undefined) queryParams.status = params.status;
  if (params.sortBy !== undefined) queryParams.sortBy = params.sortBy;
  if (params.sortDir !== undefined) queryParams.sortDir = params.sortDir;
  if (params.search && params.search.trim())
    queryParams.search = params.search.trim();

  try {
    const response = await axiosInstance.get(`${baseUrl}/admin/settlements`, {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getSettlementById = async (id) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/admin/settlements/${id}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getSettlementStats = async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/admin/settlements/stats`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

// Manually settles a collection whose automatic payout did not go through.
// The endpoint keys on the PAYMENT reference (paymentRefNo on a settlement
// record, refNo on a transaction) — NOT settlementReferenceId, which is a
// different value on many records.
export const settleManually = async ({ paymentRefNo }) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/transactions/settlements/doManualByAdmin`,
      {},
      { params: { refNo: paymentRefNo } },
    );
    return response.data;
  } catch (error) {
    throw toSettlementError(error);
  }
};
